<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer005">
<p class="Paragraph-Style-2">“Sister, I hear the thunder of new wings.”</p>
<p class="Basic-Paragraph ParaOverride-1">—Percy Bysshe Shelley, <span class="CharOverride-18">Prometheus </span><span class="CharOverride-18">Unbound</span></p>
</div>
<div class="_idGenObjectLayout-1">
<div class="Basic-Text-Frame" id="_idContainer006">
</div>
</div>
<div class="Basic-Text-Frame" id="_idContainer007">
</div>
<div class="Basic-Text-Frame" id="_idContainer008">
</div>
<div class="Basic-Text-Frame" id="_idContainer009">
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// A_Storm_in_the_Stars.FINALHC37.vue?8db7b290